import styled from 'styled-components';

export const StyledPtwStatus = styled.div`
  display: flex;
  flex-direction: column;
  color: var(--color-text-main);
  width: 350px;
  padding: 15px;
  box-shadow: 0px 0px 6px 0px #00000026;
  border-radius: 5px;
  background-color: #ffffff;

  .component-title {
    font-size: 16px;
    font-weight: 600;
    color: #2f2f35;
    margin-bottom: 5px;
  }

  .component-body {
    padding: 0px 10px;
    gap: 7px;
    display: flex;
    flex-direction: column;
  }

  .table-area {
    border: 1px solid #dadada;
    border-radius: 8px;
  }
  .table-area .title {
    background-color: #f4f4f4;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    border-bottom: 1px solid #dadada;
    font-size: 12px;
    font-weight: 400;
    color: #2f2f35;
    padding: 1px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .table-area .item-list {
    display: flex;
    font-size: 12px;
    font-weight: 400;
    color: #2f2f35;
  }

  .table-area .item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1 1;
    padding: 3px;
  }

  .table-area .item .value-text {
    font-size: 20px;
    font-weight: 600;
    line-height: 20px;
  }

  .table-area .item .sub-value-text {
    font-size: 10px;
    font-weight: 500;
    color: #757575;
    line-height: 10px;
  }

  .table-area .item:not(:last-child) {
    border-right: 1px solid #dadada;
  }
`;
